import { Check2 } from 'blaze-ui/icons'
import { ArticleView } from 'types'
import { useArticleViewLink } from 'hooks/useArticleViewLink'
import { useHistory } from 'react-router-dom'
import { Button } from 'blaze-ui/Button'

export const DoneButton = () => {
  const { to } = useArticleViewLink({ articleView: ArticleView.Commenting })
  const history = useHistory()

  return (
    <Button
      frontIcon={Check2}
      variant="editor"
      rounded
      aria-label="Done"
      size="lg"
      onPress={() =>
        history.replace({
          pathname: to.pathname,
          search: to.search,
        })
      }
    >
      Done
    </Button>
  )
}
